import React from "react";
import profileImg from "../assets/profile.jpg"; // your photo

export default function About() {
    return (
        <div className="container mt-5 pt-5">
            <h2 className="fw-bold mb-4">About Me</h2>

            <div className="row align-items-center">
                {/* LEFT: TEXT */}
                <div className="col-md-8">
                    <p className="">
                        I’m <strong>Dhanashree Raut</strong>, a Backend / Full Stack Developer
                        with hands-on experience in building scalable, data-driven web
                        applications. I enjoy solving real-world problems using clean
                        backend logic and well-structured systems.
                    </p>

                    <p className="">
                        I have worked extensively with <strong>Node.js</strong>,
                        <strong> React</strong>, <strong>PHP</strong>, and
                        <strong> SQL</strong>, and I am comfortable working across the full
                        development lifecycle—from designing APIs to integrating frontend
                        components.
                    </p>

                    <p className="">
                        I’m always eager to learn new technologies, improve system
                        performance, and write maintainable code. I enjoy collaborating
                        with teams and turning complex requirements into practical
                        solutions.
                    </p>

                    {/* QUICK HIGHLIGHTS */}
                    <ul className="mt-3">
                        <li className="">1.5+ year of backend development experience</li>
                        <li className="">Strong understanding of databases & APIs</li>
                        <li className="">Experience with production applications</li>
                        <li className="">Comfortable with Git & collaborative workflows</li>
                    </ul>

                    {/* SOCIAL & CONTACT LINKS */}
                    <div className="mt-4">
                        <a
                            href="https://www.linkedin.com/in/dhanashree-raut-3a763420b/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-outline-light me-2 mb-2"
                        >
                            LinkedIn
                        </a>

                        <a
                            href="https://github.com/Dhanashree-Raut"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-outline-light me-2 mb-2"
                        >
                            GitHub
                        </a>

                        <a
                            href="mailto:daraut0203@gmail.com"
                            className="btn btn-outline-light me-2 mb-2"
                        >
                            Email
                        </a>

                        <a
                            href="/resume.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-light mb-2"
                        >
                            Resume
                        </a>
                    </div>


                    
                </div>

                {/* RIGHT: IMAGE */}
                <div className=" d-none d-md-block col-md-4 text-center mt-4 mt-md-0 about-us-right">
                    <div className="about-image-wrapper">
                        <img
                            src={profileImg}
                            alt="Profile"
                            className="img-fluid about-img"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
